import { useEffect, useRef, useState } from "react";
import { hasCachedPrivateMedia } from "@/hooks/usePrivateMedia";
import { cn } from "@/lib/utils";
import type { PrivateImageProps } from "@/types/creative-library";
import { PrivateImage } from "./PrivateImage";

/** Don't fetch private thumbnail bytes until a navigation row enters the viewport. */
export function LazyPrivateImage(props: PrivateImageProps) {
  const container = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(() =>
    hasCachedPrivateMedia(props.source),
  );
  useEffect(() => {
    if (visible) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: "120px" },
    );
    if (container.current) observer.observe(container.current);
    return () => observer.disconnect();
  }, [visible]);
  return (
    <div
      ref={container}
      className={cn("h-full w-full", !visible && "bg-primary/5")}
    >
      {visible && <PrivateImage {...props} />}
    </div>
  );
}
